export default function popupsInit() {
  const popup = Array.prototype.slice.call(document.querySelectorAll('.js-popup'));
  const closePopupBtn = Array.prototype.slice.call(document.querySelectorAll('.js-close-popup'));

  Array.prototype.slice.call(document.querySelectorAll('.js-popup-button')).forEach(btn => {
    btn.addEventListener('click', (e) => {
      const self = e.currentTarget;
      const target = self.dataset.popupTarget;
      Array.prototype.slice.call(document.querySelectorAll(`.js-popup[data-popup="${target}"]`))
        .forEach(elem => {
          const element = elem;
          element.style.display = 'block';
        }
      );
      Array.prototype.slice.call(document.querySelectorAll(`.js-popup[data-popup="${target}"]`))
        .forEach(elem => {
          const element = elem;
          element.classList.add('is-open');
        }
      )
    });
  });

  document.addEventListener("click", (e) => {
    if (e.target.closest(".js-popup") || e.target.closest('.js-popup-button')) return;

    popup.forEach(elem => {
      const element = elem;
      if (element.classList.contains('is-open')) {
        element.style.display = 'none';
        element.classList.remove('is-open');
      }
    })
  });


  closePopupBtn.forEach(elem => [
    elem.addEventListener('click', (e) => {
      const { target } = e.currentTarget.dataset;
      Array.prototype.slice.call(document.querySelectorAll(`.js-popup[data-popup="${target}"]`))
        .forEach(el => {
          const element = el;
          element.style.display = 'none';
        })
    })
  ]);
}
